import React, { useContext } from 'react';
import { Context as CountriesContext } from '../context/CountriesContext';
import { Doughnut } from 'react-chartjs-2';
import { Paper } from '@material-ui/core';
import '../styles/DoughnutGraph.css';
import { findCountry, statOptions } from '../utils';
import numeral from 'numeral';

function DoughnutGraph() {
  const { state } = useContext(CountriesContext);
  const country = findCountry(state.countries, state.selectedCountry);

  // TODO: make graph bigger
  return (
    <Paper className="doughnut-graph">
      <Doughnut
        className="graph"
        options={options(country, 'red')}
        data={data(country)}
      />
    </Paper>
  );
}

const options = country => ({
  title: {
    display: true,
    text: `${country.country} Data`,
    fontSize: 18,
    fontColor: 'black'
  },
  responsive: true,
  maintainAspectRatio: false
});

const data = country => ({
  labels: ['Cases', 'Recovered', 'Deaths'],
  datasets: [
    {
      data: [country.cases, country.recovered, country.deaths],
      backgroundColor: [
        statOptions.cases.color,
        statOptions.recovered.color,
        statOptions.deaths.color
      ]
    }
  ]
});

export default DoughnutGraph;
